export enum ProfileAction {
  MyOrders = 'MyOrders',
  MyAccount = 'MyAccount',
  MyWallets = 'MyWallets',
  ChangeProfile = 'ChangeProfile',
  SignOut = 'SignOut',
  GuestOnBoarding = 'GuestOnBoarding',
}
